import { useMemo } from "react";
import { Card, Flex, Text } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import {
  DocumentMetadataValue,
  formatDocumentType,
  formatSubType,
  getMetadataValue,
} from "~/pages/Compliance/utils/documentUtils";
import { formatShortFormDate } from "~/utils/datetime";
import { capitalizeEachWord } from "~/utils/strings";
import { DetailsRow } from "../DetailsRow";
import { profileDetailsHeader } from "../styles_vanilla.css";

type Props = {
  id: number;
  name: string;
  s3Link: string;
  documentPurpose?: {
    baseType?: string | null;
    expires?: boolean | null;
  } | null;
  status?: string | null;
  metadata?: DocumentMetadataValue[] | null;
};

export const DocumentDetails = ({ document }: { document: Props }) => {
  const documentDetails = useMemo(() => {
    const expiry = getMetadataValue(document.metadata, "expiry");
    const certified = getMetadataValue(document.metadata, "certified");

    return [
      { label: "Document type", value: formatDocumentType(document.documentPurpose?.baseType) },
      {
        label: "Document sub-type",
        value: formatSubType(getMetadataValue(document.metadata, "type")),
      },
      { label: "Expiration date", value: expiry ? formatShortFormDate(expiry) : "--" },
      { label: "Certified document", value: certified === "true" ? "Yes" : "No" },
      { label: "Document status", value: capitalizeEachWord(document.status) || "--" },
    ];
  }, [document]);

  return (
    <Card>
      <Text className={profileDetailsHeader}>Profile Details</Text>
      <Flex flexDirection="column" gap={Sizes.MD}>
        {documentDetails?.map((item) => (
          <DetailsRow key={item.label} label={item.label} value={item.value} />
        ))}
      </Flex>
    </Card>
  );
};
